import { render, staticRenderFns } from "./MetaReferrals.vue?vue&type=template&id=2d7f6dc2&scoped=true"
import script from "./MetaReferrals.vue?vue&type=script&lang=js"
export * from "./MetaReferrals.vue?vue&type=script&lang=js"
import style0 from "./MetaReferrals.vue?vue&type=style&index=0&id=2d7f6dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f6dc2",
  null
  
)

export default component.exports